// extracted by mini-css-extract-plugin
export default {"base":"link_base__H6TfI"};